import { Directive, ElementRef, Input, AfterContentInit } from '@angular/core';

@Directive({
  selector: '[appAutoFocusDirective]'
})
export class AutoFocusDirectiveDirective {
  @Input() public autoFocus: boolean;

  constructor(
    private _el: ElementRef
  ) { }

  public ngAfterContentInit(){
    setTimeout(() => {
      this._el.nativeElement.focus();
    }, 2000);
  }
}
